/**
 * V2 Input — themed to V2 tokens, faithful to the `.inp` rule in
 * design_reference/styles/app.css (sunken well + accent focus ring).
 */

import { forwardRef } from 'react';
import type { InputHTMLAttributes } from 'react';
import { cn } from '../../../lib/utils';

/** Props for the V2 Input (native input attributes). */
export type InputProps = InputHTMLAttributes<HTMLInputElement>;

/** V2 text input. */
export const Input = forwardRef<HTMLInputElement, InputProps>(
  ({ className, type = 'text', ...props }, ref) => (
    <input
      ref={ref}
      type={type}
      className={cn(
        'w-full h-[34px] px-[11px] rounded-[var(--r-md)]',
        'bg-[var(--bg-inset)] border border-[var(--bd)] text-[var(--tx-hi)] text-[13px]',
        'shadow-[inset_0_1px_1px_rgba(0,0,0,.15)] outline-none',
        'placeholder:text-[var(--tx-faint)]',
        'focus:border-[var(--accent-line)] focus:shadow-[0_0_0_3px_var(--accent-soft)]',
        'disabled:opacity-50 disabled:pointer-events-none',
        className,
      )}
      {...props}
    />
  ),
);
Input.displayName = 'Input';
